import { Note } from "tonal";
import { Instrument } from "../components/InstrumentSelector";

export const formatTuningDisplay = (instrument: Instrument, tuning: string[]) => {
    return tuning
      .map((note, index) => {
        const pitchClass = Note.pitchClass(note);
        return instrument.hasDroneString && index === 0 
          ? pitchClass.charAt(0).toLowerCase() + pitchClass.slice(1) 
          : pitchClass;
      })
      .join('');
  };